import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M6.5 9c.82 0 1.5.68 1.5 1.5v1c0 .6-.4 1.1-.9 1.4l.49 1.13c.19.46-.14.97-.64.97l-.1001-.0074c-.2304-.034-.4349-.1838-.5399-.4026L5.59 13h-1.1v1.31c0 .38-.31.69-.69.69h-.11c-.38 0-.69-.31-.69-.69V10c0-.55.45-1 1-1zm5 0c.73 0 1.37.5 1.55 1.22l.97 3.88c.11.46-.24.9-.71.9l-.1113-.0083c-.2906-.044-.5276-.2573-.5987-.5417l-.23-.95h-1.75l-.24.95c-.08.32-.37.55-.7.55l-.0987-.0066c-.4189-.0564-.7127-.4663-.6013-.8934l.97-3.89C10.13 9.5 10.77 9 11.5 9zm9.05 0l.0988.0066c.4188.0564.7126.4663.6012.8934l-1.09 4.38c-.11.42-.49.72-.92.72l-.1159-.0073c-.381-.0482-.7041-.3309-.8041-.7127l-.58-2.32-.58 2.32c-.11.42-.49.72-.92.72l-.1159-.0073c-.381-.0482-.705-.3309-.8141-.7127L14.22 9.9c-.11-.46.24-.9.71-.9l.1113.0083c.2906.044.5276.2573.5987.5417l.6 2.45.56-2.26c.1-.44.49-.74.94-.74l.1111.0062c.4019.0448.7372.3305.8289.7338l.56 2.26.6-2.45c.08-.32.37-.55.71-.55zm-8.8 2h-.5L11 12h1zm-5.25-.5h-2v1h2z"
  }],
  circles: []
};
var RawOnIcon = function RawOnIcon(props) {
  return renderIcon(props, iconType);
};
export { RawOnIcon };